<template>
  <div class="px-4 py-2 container-fluid">
    <div class="row mt-2">
      <div class="col-12">
        <div class="card ficha-buscador mt-4 mb-4">
          <div class="titulo">
            <h5 class="mb-0" style="display:inline-block;">Empresa {{ empresa.Codigo }}</h5>
          </div>
          <div class="descarga doble" style="right:10px!important;">
            <p @click="volverAtras"><i class="fa fa-arrow-left" aria-hidden="true"></i></p>
            <p @click="this.modalActive = true;"><i class="fa fa-pencil" aria-hidden="true"></i></p>
          </div>
        </div>
        <div class="card p-4 pb-4 detalles">
          <p class="m-0"><span>Código:</span>{{ empresa.Codigo }}</p>
          <p class="m-0"><span>CIF:</span>{{ empresa.CIF }}</p>
          <p class="m-0"><span>Nombre:</span>{{ empresa.Nombre }}</p>
          <p class="m-0"><span>Dirección:</span>{{ empresa.Direccion }}</p>
          <p class="m-0"><span>Población:</span>{{ empresa.Poblacion }}</p>
          <p class="m-0"><span>Código Postal:</span>{{ empresa.CodigoPostal }}</p>
          <p class="m-0"><span>Email:</span>{{ empresa.Email }}</p>
          <p class="m-0"><span>Teléfono:</span>{{ empresa.Telefono }}</p>
          <p class="m-0"><span>Responsable:</span>{{ empresa.NombreResponsable }}</p>
          <p class="m-0"><span>Farmacia:</span>{{ empresa.Siglas }} - {{ empresa.Titulares }}</p>
          <p class="m-0"><span style="width:200px;">Aplicar escaneo facturas:</span><b>{{ empresa.IndEscaneoFacturas=='S' ? 'Si' : 'No' }}</b></p>
        </div>
      </div>
    </div>
  </div>

  <Modal @cerrar-modal="this.modalActive=false;" :modalActive="modalActive">
    <div class="modal-content">
      <edita-empresa-form @cerrar-modal="() => { this.modalActive=false;obtenerDetalleEmpresa(); }" :key="empresa.Codigo" :codigo="empresa.Codigo" :siglas="empresa.Siglas" :escaneoFacturas="empresa.IndEscaneoFacturas" :puedeEditar="buscaPermiso('edit-empresas')"></edita-empresa-form>
    </div>
  </Modal>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import Modal from './components/Modal.vue';
import setTooltip from "@/assets/js/tooltip.js";
import EditaEmpresaForm from './components/EditaEmpresaForm.vue';
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

import { mapMutations, mapState } from "vuex";

export default {
  name: "DetalleEmpresa",
  components: {
    Modal,
    EditaEmpresaForm
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      empresa: {},
      modalActive: false,
      rolEditPermisos: []
    };
  },
  computed: {
    ...mapState(["isNavFixed", "navbarFixed", "mcolor"]),
  },
  async mounted() {
    setTooltip(this.$store.state.bootstrap);
    
  },
  async beforeMount() { 
    this.$store.state.showSidenav = true;
    if (!this.$store.state.profile.permisos) { 
      await this.$store.dispatch('profile/getPermisos');
    } 
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.obtenerDetalleEmpresa());
  },
  methods: {
    async obtenerDetalleEmpresa() {
      try { 
        const resp = await this.$store.dispatch("farmacias/detalleEmpresa", this.$route.params);
        this.empresa = resp.empresa;
      } 
      catch (error) {
        console.error("Error al obtener detalle de empresa:", error.message || error);
        showSwal.methods.showSwal({
            type: "error",
            message: "Se ha producido un error: " + (error.message || error),
            width: 500,
        });
      }
    },
    descargarCSV() {
      let csvContent = '\uFEFF"Matrícula";"Titular";"Dirección";"Parroquia";"Concello";"Codigo Postal";"Telefono";"Distancia";';
      csvContent += "\n"
      for (let row of this.proximas) {
        csvContent += `"${row.Siglas}";"${row.Titulares}";"${row.Direccion}";"${row.Parroquia}";"${row.Concello}";"${row.CodigoPostal}";"${row.Telefono}";"${row.Distancia}";` + "\n";
      }
      csvContent += "\n";
      let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'data.csv');

      link.click();
    },
    volverAtras() {
      this.$router.go(-1);
    },
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
  },
};
</script>

<style lang="scss" scoped>
.mapa {
  height:100%;
  width:auto;
  vertical-align: top;
  background-size: 100% auto;
}
.cab-marco {
  width: 100%;
  height: 70vh;
  overflow-x: auto;
}
.card {    
  overflow: hidden;
  position: relative;
}
.detalles {
  span {
    font-weight: bold;
    margin-right: 5px;
    width:150px;
    display:inline-block;
    color: #333;
  }
} 
.ficha-proximas {
  min-height:120px;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background-color:transparent; 
}
::-webkit-scrollbar-thumb {
  background: #b0b0b0; 
  border-radius: 4px;
}
</style>